export const NEW_CAMPAIGN_STEPS = [
  { key: "details", label: "Campaign Details" },
  { key: "pitch", label: "Define your pitch" },
  { key: "audience", label: "Target audience" },
  { key: "messaging_style", label: "Messaging style" },
  { key: "ai_training", label: "AI training (optional)" },
];

export const NEW_CAMPAIGN_HEADER_COPY = {
  details: {
    title: "Let's set up your campaign",
    description:
      "This helps us personalise your outreach, you can always edit this later",
  },
  pitch: {
    title: "Fine-tune your pitch",
    description:
      "Take a moment to review and personalise your pitch",
  },
  audience: {
    title: "Define your ideal audience",
    description:
      "This information helps us identify the best opportunities for your business.",
  },
  messaging_style: {
    title: "Choose your messaging styles",
    description:
      "Select up to 1 outreach style for this campaign. When you continue, your campaign will be saved. AI training is optional next.",
  },
  ai_training: {
    title: "Would you like to train your AI now or later?",
    description:`Train your AI to match your tone and messaging, or skip and come back
        anytime from the sidebar.`
  },
};

/** Sidebar label + right-panel header copy per step (single source for the wizard). */
export const NEW_CAMPAIGN_WIZARD_STEPS = NEW_CAMPAIGN_STEPS.map((step) => {
  const copy = NEW_CAMPAIGN_HEADER_COPY[step.key] || {
    title: "",
    description: "",
  };
  return {
    key: step.key,
    label: step.label,
    title: copy.title,
    description: copy.description,
  };
});

/**
 * @returns {{ key: string, label: string, done: boolean, sidebarStatus: 'complete' | 'current' | 'upcoming' }[]}
 */
export function getNewCampaignStepStates({
  formData: _formData,
  pitchData: _pitchData,
  audienceData: _audienceData,
  wizardStep = 0,
}) {
  return NEW_CAMPAIGN_STEPS.map((step, i) => ({
    key: step.key,
    label: step.label,
    done: i < wizardStep,
    sidebarStatus:
      i < wizardStep ? "complete" : i === wizardStep ? "current" : "upcoming",
  }));
}

export function getNewCampaignProgressMeta({
  formData,
  pitchData,
  audienceData,
  wizardStep = 0,
}) {
  const states = getNewCampaignStepStates({
    formData,
    pitchData,
    audienceData,
    wizardStep,
  });
  const completed = states.filter((s) => s.done).length;
  const total = states.length;
  const percent = total > 0 ? Math.floor((completed / total) * 100) : 0;
  const activeStepNumber =
    states.findIndex((s) => s.sidebarStatus === "current") + 1 || total;
  const headerKey = states.find((s) => s.sidebarStatus === "current")?.key ??
    states[states.length - 1]?.key ??
    "details";

  return {
    percent,
    activeStepNumber,
    headerKey,
    stepStates: states,
  };
}
